import { useMsal } from "@azure/msal-react";
import { GoogleLogin } from "@react-oauth/google";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import IconVisibility from "../../assets/images/ic_visibility.svg";
import IconVisibilityOff from "../../assets/images/ic_visibility_off.svg";
import {
  login,
  socialAuthentication
} from "../../context/auth/auth_action";
import { AuthContext } from "../../context/auth/auth_context";
import {
  BACKGROUND_VIDEO,
  DISABLE_REGISTRATION,
  MICROSOFT_POPUP_REDIRECT,
  MICROSOFT_SCOPE
} from "../../shared/config";
// import { SignInAndRegisterGoogle } from "../../api/userInfo";
import { useIsAuthenticated } from "@azure/msal-react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { API_URL } from "../../shared/config";

const LoginPage = ({ isDap }) => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const { dispatch } = authContext;
  const { t } = useTranslation("main");
  const [form, setForm] = useState({
    username: "",
    password: "",
    is_remember: true,
    is_vekin_login: true,
  });
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  // const { login, result, error }  = useMsalAuthentication();
  const [loginError, setLoginError] = useState("");


  const handleMicrosoftSignIn = async () => {
    // Attempt to acquire a token silently
    try {
      const response = await instance.acquireTokenSilent({
        scopes: MICROSOFT_SCOPE,
      });
      if (response?.accessToken) {
        socialAuthentication(dispatch, response?.accessToken, "microsoft");
        navigate("/");
      }

      // Now, you can use the access token for your API calls.
    } catch (error) {
      // If acquireTokenSilent fails (e.g., user not logged in), open the popup
      if (
        error?.name === "BrowserAuthError" &&
        error.errorCode === "no_account_error"
      ) {
        // console.log("we got here, you need to login", error)
        try {
          const response = await instance.loginPopup({
            scopes: MICROSOFT_SCOPE,
            prompt: "select_account",
            redirectUri: MICROSOFT_POPUP_REDIRECT,
          });
          socialAuthentication(dispatch, response?.accessToken, "microsoft");

          // Now, you can use the access token for your API calls.
        } catch (popupError) {
          // Handle any errors that occur during the popup login.
          setLoginError("error signing in with microsoft, please try again");
        }
      } else {
        // Handle other errors that occur during acquireTokenSilent.
        setLoginError("error signing in with microsoft, please try again");
      }
    }
  };

  const onClickShowPassword = () => {
    setIsShowPassword(!isShowPassword);
  };

  const onInput = (field) => (e) => {
    setForm({
      ...form,
      [field]: e.target.value,
    });
  };

  const handleLogin = (event) => {
    event.preventDefault();
    const callback_url = searchParams.get('callback_url');
  if(callback_url) {  
    login(dispatch, { ...form, callback_url});
  } else {
    login(dispatch, form);
  }

    // TODO: dap redirect enhancement// actually we don't need this anymore
    if (isDap) {
      localStorage.setItem("isDap", true);
    }
  };

  const onSuccess = async (response) => {
    socialAuthentication(dispatch, response.credential, "google");
  };

  const onFailure = (err) => {
    setLoginError("error signing in with google, please try again");
  };


  return (
    <div
    className="flex overflow-hidden relative justify-center items-center w-full h-screen bg-black bg-no-repeat bg-cover"
  >
    <video autoPlay loop muted className="fixed z-0 w-auto min-w-full max-w-none min-h-full">
        <source src={BACKGROUND_VIDEO} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
   <div className="absolute inset-0 w-auto min-w-full max-w-none min-h-full opacity-10 bg-vekin"></div>

      <div className="flex fixed z-10 flex-col justify-between p-8 w-96 bg-white rounded-xl shadow-md">
        <form onSubmit={handleLogin}>
          <h2 className="mb-4 text-3xl font-bold text-vekin">{t('login.sign_in')}</h2>
          {authContext?.error && (
            <div style={{ marginTop: 0, color: "#AF2324", fontSize: 12 }}>
              {loginError || "Please try again"}
            </div>
          )}
          <input
            type="text"
            value={form.username}
            placeholder={t("login.username")}
            onChange={onInput("username")}
            className="px-4 w-full h-12 rounded-md border-2 border-gray-200"
          />
          <div className="relative mt-[20px]">
            <input
              type={isShowPassword ? "text" : "password"}
              value={form.password}
              placeholder={t("login.password")}
              onChange={onInput("password")}
              className="px-4 w-full h-12 rounded-md border-2 border-gray-200"
              
            />
            <div className="flex absolute inset-y-0 right-0 items-center pr-3 text-sm leading-5">
              <img
                src={isShowPassword ? IconVisibilityOff : IconVisibility}
                alt=""
                className="cursor-pointer"
                onClick={onClickShowPassword}
              />
            </div>
          </div>

          <div className="flex flex-row gap-4 justify-end items-center mt-2 accent-emerald-700">
            <Link
              to={"/forget-password"}
              className="text-sm underline hover:opacity-80"
            >
              {t("login.forgot_password")}
            </Link>
          </div>
          <button
            type="submit"
            className="mt-4 w-full h-12 text-white rounded-md transition-colors duration-100 bg-vekin hover:bg-vekin-green100"
          >
            {t("login.sign_in")}
          </button>
        </form>

        {!DISABLE_REGISTRATION && (
          <div className="flex gap-2 justify-center pt-10 w-full text-sm text-md">
            <p>{t("login.new_here")} </p>
            <Link
              to={`/signup`}
              className="font-semibold text-vekin hover:underline"
            >
                {t("login.create_account")}
              </Link>
            </div>
        )}

        <div className="flex justify-center w-full">
          <div className="flex flex-col items-center pt-8 w-full max-w-sm">
            <div className="flex items-center mb-6 w-full">
              <hr className="flex-1 border-gray-300" />
              <span className="px-3 text-sm text-gray-500">
                Or continue with
              </span>
              <hr className="flex-1 border-gray-300" />
            </div>

            <div className="flex flex-col gap-3 w-full">

              <button
                onClick={handleMicrosoftSignIn}
                type="button"
                className="flex gap-3 justify-center items-center px-4 py-3 w-full text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 shadow-sm transition-all duration-200 hover:bg-gray-50 hover:border-gray-400 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 23 23"
                >
                  <path fill="#f25022" d="M1 1h10v10H1z" />
                  <path fill="#00a4ef" d="M12 1h10v10H12z" />
                  <path fill="#7fba00" d="M1 12h10v10H1z" />
                  <path fill="#ffb900" d="M12 12h10v10H12z" />
                </svg>
                Sign in with Microsoft
              </button>

              <div className="flex justify-center">
                <GoogleLogin
                  onSuccess={onSuccess}
                  onError={onFailure}
                  theme="outline"
                  size="large"
                  text="signin_with"
                  shape="rectangular"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-4 border-t border-gray-200">
          <Link
            to={"/privacy-policy"}
            className="mt-2 text-sm underline hover:opacity-80"
          >
            {t("login.privacy_policy")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
